import '../../styles/main.scss';
import '../../styles/pages/about.scss';
import { i18n } from '../../../i18n/i18n.js';
import { componentLoader } from '../components/loadComponents.js';
import { setupNavigation } from '../utils/navMenu.js';
import { initAccordion } from '../components/accordion.js';
import { sectionReveal } from '../utils/scrollReveal.js';

// 确保全局可以访问i18n
window.i18n = i18n;

// DOMContentLoaded 事件处理
document.addEventListener('DOMContentLoaded', async () => {
  // 加载页面组件
  await componentLoader.loadAllComponents();
  
  // 初始化多语言功能
  await i18n.init();
  
  // 设置导航菜单与高亮
  setupNavigation();
  
  // 初始化手风琴组件
  initAccordion('.accordion', {
    multiple: false,
    defaultOpen: 0, // 默认展开第一项
  });
  
  // 初始化滚动显现动画
  const sections = document.querySelectorAll('section');
  sectionReveal.reveal(Array.from(sections));
});